import React, { useState, useEffect } from 'react';
import styles from './Brands.module.css';

const Brands = () => {
    const [brands, setBrands] = useState([]);
    const [settings, setSettings] = useState({
        title: 'Бренды',
        showTitle: true,
        speed: 20,
        pauseOnHover: true
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadBrands();
    }, []);

    const loadBrands = async () => {
        try {
            const [brandsRes, settingsRes] = await Promise.all([
                fetch('http://localhost:4000/api/content/brands?field=items'),
                fetch('http://localhost:4000/api/content/brands?field=settings')
            ]);

            const brandsData = await brandsRes.json();
            const settingsData = await settingsRes.json();

            let allBrands = brandsData.data || [];
            allBrands.sort((a, b) => (a.order || 0) - (b.order || 0));

            setBrands(allBrands.filter(b => b.visible));
            setSettings(settingsData.data || { title: 'Бренды', showTitle: true, speed: 20, pauseOnHover: true });
        } catch (error) {
            console.error('Ошибка загрузки брендов:', error);
        } finally {
            setLoading(false);
        }
    };

    if (loading || brands.length === 0) return null;

    // Дублируем бренды для бесконечной прокрутки
    const doubledBrands = [...brands, ...brands];

    return (
        <section className={styles.brands}>
            <div className={styles.container}>
                {settings.showTitle && (
                    <h2 className={styles.title}>{settings.title}</h2>
                )}

                <div className={styles.marqueeWrapper}>
                    <div className={styles.marquee}>
                        <div
                            className={styles.marqueeContent}
                            style={{
                                animationDuration: `${settings.speed}s`,
                                animationPlayState: settings.pauseOnHover ? 'running' : 'running'
                            }}
                        >
                            {doubledBrands.map((brand, idx) => (
                                <div key={`${brand.id}-${idx}`} className={styles.brandItem}>
                                    {brand.type === 'image' && brand.imageUrl ? (
                                        <img
                                            src={`${brand.imageUrl}`}
                                            alt={brand.name}
                                            className={styles.brandImage}
                                        />
                                    ) : (
                                        <>
                                            <span className={styles.brandEmoji}>{brand.emoji || '✨'}</span>
                                            <span className={styles.brandName}>{brand.name}</span>
                                        </>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Brands;